export default __webpack_public_path__ + "static/media/galeria.f58281b4.jpg";